// extracted by mini-css-extract-plugin
export var divider = "_f6-7";
export var itemsToggle = "_f6-8";
export var mergeModal = "_f6-1";
export var optionCard = "_f6-4";
export var radioGroup = "_f6-6";
export var radioOption = "_f6-0";
export var selected = "_f6-5";
export var shipmentOptions = "_f6-2";
export var tableOptions = "_f6-3";